<template>
  <div class="settings-module-root">
    <ba-header activeModule="Global Charts" disable-menu="true">
    </ba-header>
    <div class="u-p4 main-content">
      <h2 class="c-heading__page u-mt3 u-pt5">Global Charts</h2>
      <div class="container">
        <ChartsComponent></ChartsComponent>
      </div>
    </div>
  </div>
</template>

<script>
  import ChartsComponent from '@/modules/charts/charts.component.vue'
  import config from '@/config'

  export default {
    components: {
      ChartsComponent
    },
    methods: {
      getURL (chartType) {
        return `${config.url}/carrier-portal/chart/${chartType}/`
      },
      eDeliveryEnabled () {
        return true
      },
      detailsAvailable () {
        return true
      }
    }
  }
</script>

